import { errorMessage } from '~/utils/policy-studio/errors'

/** The one failure handler for Policy Studio: every action that can fail
 *  goes through `attempt`, so a toast and a Groundcover report are never
 *  forgotten on a new call site. */
export const useStudioAction = () => {
  const toast = useToast()
  const { $groundcover } = useNuxtApp()

  /** Runs `action`; on failure toasts `failure` with the error's message,
   *  reports it to Groundcover, and resolves false. Never throws. */
  const attempt = async (
    action: () => Promise<unknown>,
    failure: string,
  ): Promise<boolean> => {
    try {
      await action()
      return true
    } catch (error) {
      toast.add({
        title: failure,
        description: errorMessage(error),
        color: 'error',
      })
      $groundcover?.captureException(
        error instanceof Error ? error : new Error(errorMessage(error)),
        { area: 'policy-studio', action: failure },
      )
      return false
    }
  }

  return { attempt }
}
